export default "__VITE_ASSET__sqjmRdgo__"